import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { FORMS, PAGE_BANNERS } from "../data/content";
import { Download, FileText } from "lucide-react";

export default function DownloadForms() {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.clinic} alt="Download Forms" fallbackKey="clinic" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>Forms</h1>
          <p>
            Please download, print and fill out the appropriate intake packet prior to your first visit.
            Bringing your completed packet to your appointment helps Dr. May make the most of your time together.
          </p>
          <ul className="!list-none !pl-0 grid sm:grid-cols-2 gap-3">
            {FORMS.map((f) => (
              <li key={f.file} className="!mb-0">
                <a
                  href={`https://web.archive.org/web/2024/https://www.nourishnaturalhealth.org/wp-content/uploads/2011/12/${f.file}`}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 border border-[#d6dcb6] bg-[#f6f8ec] p-3 hover:bg-[#e9eed3] transition-colors group"
                >
                  <FileText className="w-5 h-5 text-[#7d8e54] flex-shrink-0" />
                  <span className="flex-1 nn-link group-hover:no-underline">{f.label}</span>
                  <Download className="w-4 h-4 text-[#7d8e54]" />
                </a>
              </li>
            ))}
          </ul>
        </article>
      </div>
    </div>
  );
}
